import * as SG from 'styles';

import { Image } from 'components/Image';
import { Loader } from 'components/Loader';
import { SoldSticker } from 'components/common/SoldSticker/SoldSticker';

import { TechnicalData } from '../TechnicalData';
import { useProduct } from './SingleProduct.hooks';
import * as S from './SingleProduct.styles';
import { Actions } from './components/Actions';
import { Modals } from './components/Modals';
import { Scales } from './components/Scales';

export function SingleProduct(): React.ReactElement {
  const {
    product,
    isProductModalVisibleSet,
    technicalDataFetch,
    image,
    technicalData,
    language,
    productDetailsFetch,
  } = useProduct();

  return (
    <Loader isLoading={productDetailsFetch.isLoading}>
      <SG.Inner>
        <SoldSticker soldQty={product?.sold || 0} />
        <S.Wrapper>
          {image ? (
            <S.ImageWrapper onClick={() => isProductModalVisibleSet(true)}>
              <Image source={image} alt="product" />
            </S.ImageWrapper>
          ) : null}
          {product && product.sizeQtyPrice && product.scale ? <Scales /> : undefined}
          <Actions technicalData={technicalData} />
        </S.Wrapper>
      </SG.Inner>
      <Loader isLoading={technicalDataFetch.isLoading}>
        {technicalData ? (
          <TechnicalData
            desc={
              language === 'en'
                ? technicalData?.englishDescription
                : technicalData?.italianDescription
            }
            accessories={
              language === 'en'
                ? technicalData?.englishAccessories
                : technicalData?.italianAccessories
            }
            technologies={technicalData.technologiesImages}
          />
        ) : undefined}
      </Loader>

      <Modals />
    </Loader>
  );
}
